<!--隐私协议-->
<template>
    <div class="privacy">
        <div class="container">

            <p>接受条款 </P>
            <p>更新日期：2024年11月30日 </P>
            <p>生效日期：2024年11月30日 </P>
            <p>本政策适用于江苏爱驿站信息科技有限公司的父母牵缘产品及相关服务。 </P>
            <p>您所使用的“父母牵缘”应用的运营者的公司名称为江苏爱驿站信息科技有限公司，注册地址为：江苏省徐州市泉山区淮海西路延长段西城华庭4号楼2-521室，个人信息保护相关负责人联系方式为：JB@aiyizhan.com </P>
            <p>如您对本政策或相关事宜有疑问或建议等，您可以通过如下投诉渠道与我们取得联系： </P>
            <p>举报邮箱：JB@aiyizhan.com </P>
            <p>本隐私政策将帮助您了解以下内容： </P>
            <p>一、引言 </P>
            <p>1、我们如何收集和使用您的个人信息 </P>
            <p>2、我们如何使用 Cookie 、同类技术和SDK技术 </P>
            <p>3、我们如何共享、转让、公开披露您的个人信息 </P>
            <p>4、我们如何保护您的个人信息 </P>
            <p>5、您如何管理您的个人信息/您的权利 </P>
            <p>6、我们如何处理未成年人的个人信息 </P>
            <p>7、存储信息的地点和期限，您的个人信息如何在全球范围转移 </P>
            <p>8、本隐私政策如何更新 </P>
            <p>9、如何联系我们/用户申诉渠道和反馈机制 </P>
            <p>10、广告/我们向您发送的信息 </P>
            <p>11、适用范围 </P>
            <p>江苏爱驿站信息科技有限公司（以下统称“我们”）深知个人信息对您的重要性，并会尽力保护您的个人信息安全可靠，我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则，目的明确原则，选择同意原则，最少够用原则，确保安全原则，主体参与原则，公开透明原则等等。同时我们承诺，我们将按业界成熟的安全解决方案，采取相应的安全保护措施来保护您的个人信息。 </P>
            <p>请在使用我们的产品、服务前，仔细阅读并了解本《隐私政策》。 </P>
            <p>二、父母牵缘对其收集的用户信息严格保密，并建立健全用户信息保护制度，以便为每一位用户提供可靠、放心的服务： </P>
            <p>1.清晰明确 </P>
            <p>我们将尽可能采用通俗易懂的文字为您阐释隐私政策，以便您能更清晰地了解我们如何保护和处理所收集的您的信息。 </P>
            <p>2.保障权益 </P>
            <p>我们将采取充分、合理的措施保障您的隐私权益。 </P>
            <p>3.尊重用户 </P>
            <p>我们尊重用户的选择权、知情权等权利的自由行使，允许您管理您的个人信息。 </P>
            <p>4.必要安全 </P>
            <p>我们将仅收取必要的信息，并利用这些信息为您提供安全、详实的服务。 </P>
            <p>5.及时贴心 </P>
            <p>我们将随时聆听您的询问，并尽快为您解答您的疑问。 </P>
            <p>希望您仔细阅读《隐私政策》（以下简称“本政策”），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并在是否选择服务以及选择何种服务时更加符合您的真实意思表示。 </P>
            <p>请您在注册或使用我们的服务前仔细阅读本政策，若您使用我们提供的服务，即表示您认同我们在本政策中所述内容。 </P>
            <p>如您有问题，请联系我们。 </P>

            <p>三、我们如何收集和使用您的个人信息 </P>
            <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，我们会出于本政策所述的以下目的，收集和使用您的个人信息： </P>
            <p>收集个人信息的业务功能以及收集的个人信息 </P>
            <p>父母牵缘的主要功能为婚恋相亲，根据《常见类型移动互联网应用程序必要个人信息范围规定》，婚恋相亲类功能必要信息为注册用户<strong>移动电话号码</strong>，婚恋相亲人的性别、年龄、婚姻状况、<strong>AndroidID</strong>、<strong>OAID</strong>、<strong>ICCID</strong>等，您同意《隐私政策》仅代表您知悉和同意使用婚恋相亲功能时我们收集、处理相关必要信息，不代表您同意我们收集、处理非必要个人信息。 </P>
            <p>我们将向您提供下列服务，并在提供下列服务时分别收集如下所列的信息： </P>
            <p>通讯录、麦克风：当您使用即时通讯功能时，我们将向您申请获取<strong>通讯录、麦克风</strong>权限； </P>
            <p>相机、相册、文件：当您使用上传附件功能时，我们将向您申请获取<strong>相机、相册、文件</strong>访问权限； </P>
            <p>短信：当您使用验证码快速填写功能时，我们将向您申请获取<strong>短信</strong>权限； </P>
            <p>电话：当您使用读取通话状态和移动网络信息、拨打电话、使用呼叫转移功能时，我们将向您申请获取<strong>电话</strong>权限； </P>
            <p>定位：当您使用访问位置信息、在后台使用位置信息功能时，我们将向您申请获取<strong>定位</strong>权限； </P>
            <p>IMEI、IMSI、MAC地址：当您使用唯一标识用户身份功能时，我们将向您申请获取<strong>IMEI、IMSI、MAC</strong>地址权限。 </P>
            <p>ICCID：当您使用一键登录功能（阿里号码认证）时，我们将向您申请获取ICCID</P>
            <p>我们收集用户的<strong>面部特征数据</strong>用于对用户进行与数据库系统留存的当前用户的面部照片进行比对，已确定是该用户在使用当前账号。</P>
            <p>面部数据比对系统我们使用了腾讯公司提供的解决方案，当次比对信息不对用户的面部数据进行存储。我们不会与除了腾讯公司外的第三方共享您的面部数据信息</P>
            <p>1.为帮助您使用父母牵缘的相关服务。 </P>
            <p>为完成创建账号，并保护您的账号安全，您需要提供以下信息：<strong>手机号码授权、性别、出生日期</strong>。 </P>
            <p>若您不提供这类信息，您将无法正常使用我们的服务。 </P>
            <p>为了父母牵缘的用户都拥有丰富完善的社交资料，以便挑选合适的交友对象，以及提升匹配准确度，提高交友效率，我们建议您提供以下信息：<strong>昵称、身高、家乡、现居地、自我介绍、个人照片（如您选择拍摄头像则需相机权限）、学历、毕业学校、职业、年收入</strong>。 </P>
            <p>为了保障父母牵缘真实、安全的社交环境，我们建议您进行<strong>实名及人脸认证</strong>。为进行上述认证，您需要提供<strong>真实姓名、身份证号、个人生物信息中的面部特征信息，并授权身份证核验</strong>。 </P>
            <p><strong>出生日期、身高、现居地、年收入、真实姓名及身份证号、个人生物识别信息中的面部特征信息属于敏感信息。</strong></P>
            <p>若您不提供这类信息，您可能无法使用我们的全部服务。 </P>
            <p>如果您提供以下额外信息，将有助于我们给您提供更好的匹配服务和使用体验：<strong>学历认证材料</strong>（能证明您学历学校的相关信息），收集此类信息主要是为了帮助您完成您的学历认证。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。 </P>
            <p>您提供的上述信息，将在您使用本服务期间持续授权我们使用。我们会一直保存您的信息直至您注销账号。在您注销账号时，我们将停止使用并删除或匿名化处理上述信息。 </P>
            <p>上述信息仅存储于中华人民共和国境内，如需跨境传输，我们将会单独征得您的授权同意。 </P>
            <p>2.为帮助您与其他用户进行聊天。 </P>
            <p>当您使用聊天服务时，我们没有要求您必须提供的信息。 </P>
            <p>如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<strong>相机权限、麦克风权限、个人位置信息</strong>。收集此类信息主要是为了发送拍摄的照片、语音信息及定位信息。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。 </P>
            <p>个人位置信息属于敏感信息。 </P>
            <p>您提供的上述信息，将在您使用本服务期间持续授权我们使用。我们会一直保存您的信息直至您注销账号。在您注销账号时，我们将停止使用并删除或匿名化处理上述信息。 </P>
            <p>上述信息仅存储于中华人民共和国境内，如需跨境传输，我们将会单独征得您的授权同意。 </P>
            <p>3.为帮助您使用滑动卡片服务。 </P>
            <p>当您打开父母牵缘APP时，会自动进入滑动卡片界面。使用滑动卡片服务时，您需要提供以下功能、信息以保证全部功能正常使用：<strong>个人位置信息</strong>。收集此类信息主要是为了实现基于地理位置的社交匹配，您每次打开APP时我们会读取您的精准位置为您匹配附近的人。 </P>
            <p>若您不提供这类信息，将不会影响使用本服务的基本业务功能。 </P>
            <p>在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的匹配服务和使用体验：我的生活、<strong>婚姻状态、车产、房产</strong>。收集此类信息主要是为了丰富资料，提升匹配准确度，提高交友效率。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。 </P>
            <p><strong>个人位置信息、我的生活、婚姻状态、车产、房产</strong>属于敏感信息。 </P>
            <p>您提供的上述信息，将在您使用本服务期间持续授权我们使用。我们会一直保存您的信息直至您注销账号。在您注销账号时，我们将停止使用并删除或匿名化处理上述信息。 </P>
            <p>上述信息仅存储于中华人民共和国境内，如需跨境传输，我们将会单独征得您的授权同意。 </P>
            <p>4.为帮助您使用视频约会功能。 </P>
            <p>当您使用视频约会功能时，您需要提供以下功能、信息以保证功能正常使用：<strong>摄像头权限、麦克风权限、视频的留存与内容查验授权</strong>。 </P>
            <p>若您不提供这类信息，您可能无法正常使用视频约会的服务。 </P>
            <p>视频的留存与内容查验授权属于敏感信息。收集此类信息主要是为了保证网络视频社交的安全性。 </P>
            <p>在使用过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：<strong>日历权限</strong>。收集此类信息主要是为了提醒您的约会日程安排。但如果您不提供这些信息，将不会影响使用本服务的基本业务功能。 </P>
            <p>您提供的上述信息，将在您使用本服务期间持续授权我们使用。我们会一直保存您的信息直至您注销账号。在您注销账号时，我们将停止使用并删除或匿名化处理上述信息。 </P>
            <p>上述信息仅存储于中华人民共和国境内，如需跨境传输，我们将会单独征得您的授权同意。 </P>
            <p>5.为帮助您使用红娘服务。 </P>
            <p>当您使用红娘服务时，我们没有要求您必须提供的信息。 </P>
            <p>6.为帮助您使用分享服务。 </P>
            <p>当您使用分享服务时，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：剪切板信息、粘贴板信息。收集此类信息主要是为了识别您的注册邀请分享方。如果您不提供这些信息，将会一定程度影响使用本服务的体验。 </P>
            <p>7.为帮助您使用支付功能。 </P>
            <p>支付功能由与我们合作的第三方支付机构向您提供服务，第三方支付机构将会需要收集您的信息，我们将无法获取您的信息。拒绝提供信息仅会使您无法使用上述支付功能，但不影响您使用父母牵缘的其他功能。 </P>
            <p>8.为帮助您使用父母牵缘AI恋爱助手功能。 </P>
            <p>您在注册、划卡、聊天等阶段，会使用到父母牵缘AI恋爱助手功能，父母牵缘AI恋爱助手会通过语音交互形式帮助您完成注册，使用划卡、聊天等功能。 </P>
            <p>当您使用父母牵缘AI恋爱助手功能时，我们没有要求您必须提供的信息。 </P>
            <p>9.为保障软件与服务的安全运营和运营质量。 </P>
            <p>为了保障软件与服务的安全运营、运行的质量及效率，我们会收集您的<strong>硬件型号、操作系统版本、IP地址、软件版本号和网络接入方式</strong>。为预防恶意程序、保障运营质量及效率，我们还会收集软件的崩溃情、操作日志、性能数据及应用来源。我们可能使用您的账户信息、设备信息、服务日志信息及我们关联方、合作方在取得您授权或依法可以共享的信息，用于判断账户安全、进行身份验证、检测及防范安全事件。</P>
            <p>10.您知悉并同意，我们在运营中可能会通过电话、短信方式向您发送多类通知，用于用户消息告知、安全验证、用户使用体验调研等。如您不愿意接受此类信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。 </P>
            <p>11.您知悉并同意，当发现您正在遭受电信诈骗或处于其他可能损害您的人身或财产安全的情况时，您同意我们通过电话、短信或其他可以联系到您的方式与您取得联系，以保护您不受侵害。 </P>
            <p>12.您知悉并同意，如您的账号因您违反平台规则等原因而被封禁，您提供的<strong>身份证号码</strong>等信息将用于为您解封账号或再次注册账号时的身份识别。 </P>

            <p>自启动或关联启动说明</P>
            <p>推送相关:为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的;
                当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有关联启动。</P>
            <p>下载相关:当您在本APP内部下载文件(比如应用内版本更新提示)，根据下载状态处理HTTP连接并监控连接中的状态变化以及系统重启来确保每一个下载任务顺利完成，特别是当用户切换不同的应用以后下载需要在后台继续进行(可能会有后台进程自启动)，以及当下载任务顺利完成后获取APK文件安装。</P>

            <p>我们如何使用收集的信息 </P>
            <p>我们将按照前述的用途使用您的信息。当我们要将信息用于本政策未载明的其他用途时，会事先征得您的同意。当我们要将基于特定目的收集的信息用于其他目的时，会事先征得您的同意。 </P>
            <p>三、我们如何使用 Cookie 、同类技术和SDK技术 </P>
            <p>Cookie </P>
            <p>为确保网站正常运转、为您获得更轻松的访问体验，我们可能会在您的计算机或移动设备上存储名为Cookie 的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。您可以在浏览器中进行相应的数据清除操作。 </P>

            <p>其他技术 </P>
            <p>除 Cookie外，我们还会在网站上使用其他同类技术。我们向您发送的会员短信通知或父母牵缘小助手站内通知可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。 </P>



            <p>SDK技术 </P>
            <p>SDK技术由与我们合作的第三方机构提供，我们仅能知悉其要求获得授权的权限。第三方机构将会需要收集您的信息，我们无法获取您的信息，除非第三方机构明确向我们披露的要收集的敏感信息。第三方机构要求获得的权限以及明确向我们披露的收集的敏感信息。和国境内收集和产生的用户个人信息存放于中华人民共和国境内。 </P>
            <p>第三方SDK服务商： </P>

            <br>

            <p>SDK名称：友盟 </P>
            <p>服务类型：统计分析、异常检测、客户端性能监控 </P>
            <p>收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等） </P>
            <p>SDK隐私政策链接：<a href="https://www.umeng.com/page/policy" target="_blank">https://www.umeng.com/page/policy</a></P>
            <br>

            <p>SDK名称：高德地图 </P>
            <p>收集数据类型：设备信息，SD卡，网络信息及位置相关信息； </P>
            <p>使用目的：用户位置定位及导航 </P>
            <p>SDK隐私政策链接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a></P>
            <br>

            <p>SDK名称：APP支付客户端SDK </P>
            <p>开发者：支付宝(杭州)信息技术有限公司 </P>
            <p>收集数据类型：设备信息、网络信息 </P>
            <p>使用目的：帮助用户完成付款 </P>
            <p>SDK隐私政策链接：<a href="https://opendocs.alipay.com/open/54/01g6qm?pathHash=01459d85" target="_blank">https://opendocs.alipay.com/open/54/01g6qm?pathHash=01459d85</a></P>
            <br>

            <p>SDK名称：微信支付 </P>
            <p>收集数据类型：设备信息、网络信息 </P>
            <p>使用目的：帮助用户完成付款 </P>
            <p>SDK隐私政策链接：<a href="https://www.tenpay.com/v3/helpcenter/low/privacy.shtml" target="_blank">https://www.tenpay.com/v3/helpcenter/low/privacy.shtml</a></P>
            <br>

            <p>SDK名称：腾讯云慧眼人脸核身 </P>
            <p>收集数据类型：人脸视频和照片 </P>
            <p>使用目的：活体检测实现实人认证 </P>
            <p>SDK隐私政策链接：<a href="https://privacy.qq.com/document/preview/4661fcc5ceb04a4f878a5874c86b34a2" target="_blank">https://privacy.qq.com/document/preview/4661fcc5ceb04a4f878a5874c86b34a2</a></P>
            <br>

            <p>SDK名称：腾讯TBS浏览服务 </P>
            <p>功能：用于提供浏览网页服务 </P>
            <p>收集数据类型：Wifi信息，SD卡，MAC地址、IMSI、bssid、IMEI、设备序列号 </P>
            <p>SDK隐私政策链接：<a href="https://x5.tencent.com/docs/privacy.html" target="_blank">https://x5.tencent.com/docs/privacy.html</a></P>
            <br>

            <p>SDK名称：网易云信即时通讯SDK </P>
            <p>使用目的：网易云信SDK的即时通讯功能。 </P>
            <p>收集个人信息类型：设备信息、联网信息、地理位置、账号信息 </P>
            <p>SDK隐私政策链接：<a href="https://netease.im/clauses?serviceType=3" target="_blank">https://netease.im/clauses?serviceType=3</a></P>
            <br>

            <p>SDK名称：腾讯开放平台SDK </P>
            <p>使用目的: 用于实现QQ、微信等分享功能 </P>
            <p>收集个人信息类型：不涉及用户信息和权限 </P>
            <p>SDK隐私政策链接：<a href="https://privacy.qq.com/policy/kids-privacypolicy" target="_blank">https://privacy.qq.com/policy/kids-privacypolicy</a></P>
            <br>

            <p>SDK名称：Crash SDK </P>
            <p>开发者：广州市动景计算机科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://yueying-docs.effirst.com/privacy.html" target="_blank">https://yueying-docs.effirst.com/privacy.html</a></P>
            <br>

            <p>SDK名称：IM_Android</P>
            <p>开发者：杭州网易质云科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://netease.im/clauses?serviceType=3" target="_blank">https://netease.im/clauses?serviceType=3</a></P>
            <br>

            <p>SDK名称：OPPO PUSH 客户端SDK</P>
            <p>开发者：OPPO广东移动通信有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://open.oppomobile.com/new/developmentDoc/info?id=11228" target="_blank">https://open.oppomobile.com/new/developmentDoc/info?id=11228</a></P>
            <br>

            <p>SDK名称：vivo PUSH-SDK</P>
            <p>开发者：维沃移动通信有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://dev.vivo.com.cn/documentCenter/doc/366" target="_blank">https://dev.vivo.com.cn/documentCenter/doc/366</a></P>
            <br>

            <p>SDK名称：友盟+应用性能监控SDK</P>
            <p>开发者：友盟同欣（北京）科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://www.umeng.com/page/policy" target="_blank">https://www.umeng.com/page/policy</a></P>
            <br>

            <p>SDK名称：友盟+社会化分享SDK</P>
            <p>开发者：友盟同欣（北京）科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://www.umeng.com/page/policy" target="_blank">https://www.umeng.com/page/policy</a></P>
            <br>

            <p>SDK名称：友盟+移动统计SDK</P>
            <p>开发者：友盟同欣（北京）科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://www.umeng.com/page/policy" target="_blank">https://www.umeng.com/page/policy</a></P>
            <br>

            <p>SDK名称：地图SDK</P>
            <p>开发者：高德软件有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a></P>
            <br>

            <p>SDK名称：定位SDK</P>
            <p>开发者：高德软件有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a></P>
            <br>

            <p>SDK名称：小米推送</P>
            <p>开发者：北京小米移动软件有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://dev.mi.com/console/doc/detail?pId=1822" target="_blank">https://dev.mi.com/console/doc/detail?pId=1822</a></P>
            <br>

            <p>SDK名称：微信OpenSDK Android</P>
            <p>开发者：深圳市腾讯计算机系统有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8" target="_blank">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a></P>
            <br>

            <p>SDK名称：性能分析-Android</P>
            <p>开发者：杭州阿里云智能科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.598730e5wsglWa" target="_blank">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.598730e5wsglWa</a></P>
            <br>

            <p>SDK名称：性能加速库</P>
            <p>开发者：华为软件技术有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://developer.huawei.com/consumer/cn/doc/development/graphics-Guides/sdk-data-security-0000001050700772" target="_blank">https://developer.huawei.com/consumer/cn/doc/development/graphics-Guides/sdk-data-security-0000001050700772</a></P>
            <br>

            <p>SDK名称：慧眼基础版SDK（Android）</P>
            <p>开发者：腾讯云计算（北京）有限责任公司 </P>
            <p>SDK隐私政策链接：<a href="https://cloud.tencent.com/document/product/1007/66043" target="_blank">https://cloud.tencent.com/document/product/1007/66043</a></P>
            <br>

            <p>SDK名称：消息推送 SDK Android</P>
            <p>开发者：每日互动股份有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://docs.getui.com/privacy/" target="_blank">https://docs.getui.com/privacy/</a></P>
            <br>

            <p>SDK名称：百度Android地图SDK（基础版）</P>
            <p>开发者：北京百度网讯科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://lbs.baidu.com/index.php?title=openprivacy" target="_blank">https://lbs.baidu.com/index.php?title=openprivacy</a></P>
            <br>

            <p>SDK名称：百度Android定位SDK</P>
            <p>开发者：北京百度网讯科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://lbs.baidu.com/index.php?title=openprivacy" target="_blank">https://lbs.baidu.com/index.php?title=openprivacy</a></P>
            <br>

            <p>SDK名称：腾讯浏览服务 X5 网页引擎 SDK</P>
            <p>开发者：深圳市腾讯计算机系统有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://rule.tencent.com/rule/preview/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d" target="_blank">https://rule.tencent.com/rule/preview/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d</a></P>
            <br>

            <p>SDK名称：轻量版地图SDK</P>
            <p>开发者：高德软件有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a></P>
            <br>

            <p>SDK名称：远程日志-android</P>
            <p>开发者：杭州阿里云智能科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.598730e5wsglWa" target="_blank">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.11186623.0.0.598730e5wsglWa</a></P>
            <br>
            <p>SDK名称：RTC_Android</P>
            <p>开发者：杭州网易质云科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://netease.im/clauses?serviceType=3" target="_blank">https://netease.im/clauses?serviceType=3</a></P>
            <br>
            <br>
            <p>SDK名称：百度oCPX转化追踪SDK</P>
            <p>开发者：北京百度网讯科技有限公司 </P>
            <p>SDK隐私政策链接：<a href="https://ocpx-devcenter.bj.bcebos.com/%E5%BA%94%E7%94%A8SDK%E8%B5%84%E6%BA%90/%E3%80%90%E7%99%BE%E5%BA%A6oCPX%E8%BD%AC%E5%8C%96%E8%BF%BD%E8%B8%AASDK%E3%80%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96%2020250303.pdf?authorization=bce-auth-v1/e2ea496b5e7f4e20bd0e5d1ce5533588/2025-03-03T03%3A24%3A50Z/-1/host/f51f435fb61f7078188b3f185fcbffa4f08b54840da573f0050f6c90ce7dcb70" target="_blank">https://ocpx-devcenter.bj.bcebos.com/%E5%BA%94%E7%94%A8SDK%E8%B5%84%E6%BA%90/%E3%80%90%E7%99%BE%E5%BA%A6oCPX%E8%BD%AC%E5%8C%96%E8%BF%BD%E8%B8%AASDK%E3%80%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96%2020250303.pdf?authorization=bce-auth-v1/e2ea496b5e7f4e20bd0e5d1ce5533588/2025-03-03T03%3A24%3A50Z/-1/host/f51f435fb61f7078188b3f185fcbffa4f08b54840da573f0050f6c90ce7dcb70</a></P>
            <br>
            <br>
             <p>SDK名称：巨量引擎转化SDK</P>
            <p>使用目的：广告投放及归因、反作弊、统计分析、减少App崩溃、提供可靠稳定的服务</P>
            <p>使用场景：向最终用户投放广告时使用</P>
            <p>SDK隐私政策链接：<a href="https://open.oceanengine.com/labels/7/docs/1708428054592516?origin=left_nav" target="_blank">https://open.oceanengine.com/labels/7/docs/1708428054592516?origin=left_nav</a></P>
            <br>
            <br>
            <p>SDK名称：阿里云号码认证SDK</P>
            <p>服务类型：本机号码一键登录和认证</P>
            <p>收集信息类型：网络类型、设备信息（含IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM State）</P>
            <p>服务类型：本机号码一键登录和认证。 </P>
            <p>SDK隐私政策链接：<a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.25842a3c6SJaX2" target="_blank">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.25842a3c6SJaX2</a></P>
            <br>
            

            <p>四、个人信息出境的情况 </P>
            <p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中华人民共和国境内。如果在未来出现个人信息出境的情况，我们将严格遵守中华人民共和国法律法规的相关规定，同时对出境信息的信息安全进行评估，并获取您的明确授权，但是您通过互联网进行跨境发布动态等个人主动行为除外。 </P>
            <p>针对以上情形，我们会确保依据本隐私政策对您的个人信息提供足够的保护。 </P>
            <p>存储信息的期限 </P>
            <p>一般而言，我们仅在为实现目的所必需的最短时间内保留您的个人信息，超过相应期限内的个人信息将会删除或匿名化进行处理。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间： </P>
            <p>1.为遵守适用的法律法规或政策等规范性文件的有关规定； </P>
            <p>2.为遵守行政机关或类似授权组织的决定等、司法机关判决、裁定、仲裁机关的裁决或其他法律程序的规定； </P>
            <p>3.我们有理由确信需要遵守法律法规等有关规定； </P>
            <p>4.为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员等第三方的人身财产安全或其他合法权益所合理必需的用途。 </P>
            <p>当父母牵缘发生停止运营的情形时，我们将采取推送通知、网站或程序内公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。 </P>
            <p>5、注销账号 </P>
            <p>您可以通过路径：“父母牵缘APP-设置-账号注销”注销您的父母牵缘账号。 </P>
            <p>在您注销父母牵缘账号后，我们将停止为您提供父母牵缘的全部产品或服务，并依据法律法规相关要求通过匿名化的方式处理您的个人信息，或删除与您账号相关的个人信息，但法律法规或监管机构对用户信息存储时间另有规定的除外。 </P>
            <p>6、本隐私政策如何更新 </P>
            <p>我们的隐私政策可能变更。如果发生业务功能变更、使用目的变更、个人信息保护相关负责人联络方式变更等情形，我们将相应修订隐私政策。 </P>
            <p>未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。对于重大变更，我们会提供显著的通知（包括我们会通过父母牵缘公示的方式、父母牵缘小助手等进行通知）。您也可以定期查看本隐私政策，以获取最新的条款。 </P>
            <p>五、本政策所指的重大变更包括但不限于： </P>
            <p>1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等； </P>
            <p>2.个人信息共享、转让或公开披露的主要对象发生变化； </P>
            <p>3.您参与个人信息处理方面的权利及其行使方式发生重大变化； </P>
            <p>4.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时； </P>
            <p>5.个人信息安全影响评估报告表明存在高风险时。 </P>
            <p>如果您在接到通知后，选择继续使用我们的服务，即表示同意受经修订的政策约束。 </P>
            <p>我们还会将本政策的旧版本存档，供您查阅，您可通过前述的联系方式向我们申请查阅。 </P>
            <p>6、如何联系我们/用户申诉渠道和反馈机制 </P>
            <p>如您对本政策或相关事宜有疑问或建议等，我们建立了个人信息保护专职部门，您可以通过如下投诉渠道与我们取得联系： </P>
            <p>举报邮箱：JB@aiyizhan.com </P>
            <p>我们将妥善受理并及时反馈您的申诉，并在验证您的用户身份后的十五天内予以回复。 </P>
            <p>如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。 </P>
            <p>7、广告/我们向您发送的信息 </P>
            <p>我们可能使用您的相关信息，在相关网站、应用、及其他渠道向您发送商业广告。 </P>
            <p>如果您不想接受我们给您发送的商业广告，您可随时通过相应产品退订功能取消。 </P>
            <p>8、适用范围 </P>
            <p>父母牵缘提供的所有服务均使用本隐私政策。但是，请您注意，本隐私政策不适用由其他公司或个人提供的服务，且该服务适用其他公司或个人的隐私政策。</P>

            <div class="footer">
                <p>江苏爱驿站信息科技有限公司</p>
            </div>
        </div>
    </div>

    <!--回到顶部-->
<!--    <van-back-top style="background-color: #fe405f"/>-->
</template>

<style lang="scss" scoped>
.privacy{
    display: flex;
    width: 100%;
    //min-height: 300px;
    background: #F8F8F8;
    .container{
        margin: 10px 10px 20px 10px;
        padding: 10px;
        background: #fff;
        text-align: left;
        border-radius: 10px;
    }
}
p {
    //margin-top: 3px;
    text-indent: 2em;
    line-height: 24px;
    font-size: 15px;
    color: #000000;
    word-break: break-all;
}

.footer{
    display: flex;
    text-align: right;
    float: right;
    p{
        font-size: 16px;
        color: #000000;
        word-break: break-all;
    }
}
</style>
<script setup lang="ts">
</script>